import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'wt-ui';

const Bar = (props) => {
  const ref = useRef(null);
  const { duration, curTime, onTimeUpdate } = props;
  const curPercentage = (curTime / duration) * 100;

  const calcClickedTime = (e) => {
    const clickPositionInPage = e.pageX;
    const bar = ref.current;
    const barStart = bar.getBoundingClientRect().left + window.scrollX;
    const barWidth = bar.offsetWidth;
    const clickPositionInBar = clickPositionInPage - barStart;
    const timePerPixel = duration / barWidth;
    return timePerPixel * clickPositionInBar;
  };

  const updateTimeOnMove = eMove => {
    onTimeUpdate(calcClickedTime(eMove));
  };

  const handleTimeDrag = (e) => {
    onTimeUpdate(calcClickedTime(e));

    document.addEventListener('mousemove', updateTimeOnMove);

    document.addEventListener('mouseup', () => {
      document.removeEventListener('mousemove', updateTimeOnMove);
    });
  };

  return (
    <Box background="transparent" direction="row-responsive" className="bar">
      <div
        ref={ref}
        className="bar__progress"
        style={{
          background: `linear-gradient(to right, rgb(80, 0, 185) ${curPercentage}%, rgba(80, 0, 185, 0.2) 0)`,
        }}
        onMouseDown={e => handleTimeDrag(e)}
        role="presentation"
      />
    </Box>
  );
};

Bar.propTypes = {
  duration: PropTypes.number.isRequired,
  curTime: PropTypes.number.isRequired,
  onTimeUpdate: PropTypes.func.isRequired,
};

export default Bar;
